export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/jeff-sheldon-688ef131f6756c2731f1e6d2279c5dd0.jpg";